import TailSelect from "tail.select.js";

export default class NavigationSelect {
	constructor() {
		this.init();
	}

	init() {
		let elements = document.querySelectorAll( '[data-navigation-select]' );
		elements.forEach( ( element ) => {
			TailSelect(element, {});

			element.addEventListener( 'change', ( e ) => {
				let value = element.value;
				window.location.replace( value );
			} );
		} );
	}
}
